export const FETCH_JOB_PHASES = 'JobPhasesModule/FETCH_JOB_PHASES';
export const ADD_JOB_PHASE = 'JobPhasesModule/ADD_JOB_PHASE';
export const DELETE_JOB_PHASE = 'JobPhasesModule/DELETE_JOB_PHASE';
export const UPDATE_JOB_PHASE = 'JobPhasesModule/UPDATE_JOB_PHASE';
export const SYNC_JOB_PHASES = 'JobPhasesModule/SYNC_JOB_PHASES';
export const HAS_TASKS_FOR_PHASE = 'JobPhasesModule/HAS_TASKS_FOR_PHASE';
